import React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Drawer from "@material-ui/core/Drawer";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import UserProfile from "../../base/views/UserProfile";
import HomeIcon from "@material-ui/icons/Home";
import Tooltip from "@material-ui/core/Tooltip";
import MenuListItems from "./MenuListItems";
import Button from "@material-ui/core/Button";
import AppsIcon from "@material-ui/icons/Apps";
import TimelineIcon from "@material-ui/icons/Timeline";
import { ClickAwayListener } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { Group } from "@material-ui/icons";

const drawerWidth = 350;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },
  appBar: {
    backgroundColor: "white",
    backdropFilter: "blur(6px)",
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: "36",
  },
  menuButtonHidden: {
    display: "none",
  },
  title: {
    flexGrow: 1,
    color: "rgba(0, 0, 0);",
  },
  drawerPaper: {
    display: "flex",
    justifyContent: "space-between",
    position: "fixed",
    backgroundColor: "rgb(22, 177, 255)",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: "hidden",
    zIndex: theme.zIndex.drawer + 2,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9.3),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: "auto",
    overflow: "auto",
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  fixedHeight: {
    height: 240,
  },
  AccountPopUp: {
    backgroundColor: "rgba(255,255,255,0.8)",
    backdropFilter: "blur(6px)",
  },
  avatar: {
    backgroundColor: theme.palette.primary.main,
  },
  typographyText: {
    color: "rgba(0, 0, 0);",
  },
}));

export default function MenuLandingPage(props) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const history = useHistory();
  const store = JSON.parse(sessionStorage.getItem("store"));

  const {
    showBaseMenu,
    menuItems,
    modules,
    hideHomeButton,
    hideDrawer,
    title,
    showAppsIcon,
    showUserManagement,
  } = props;
  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = (e, reason) => {
    setOpen(false);
  };

  return (
    <ClickAwayListener onClickAway={handleDrawerClose}>
      <div className={classes.root}>
        <CssBaseline />
        <AppBar
          position="fixed"
          className={clsx(classes.appBar, open && classes.appBarShift)}
          elevation={0}
        >
          <Toolbar className={classes.toolbar}>
            <Typography
              component="h1"
              variant="h5"
              noWrap
              className={classes.title}
              style={{ marginLeft: "4.5rem" }}
            >
              {title}
            </Typography>
            {/* Home page */}
            {store && (
              <Button
                variant="contained"
                style={{
                  backgroundColor: "rgb(22, 177, 255)",
                  borderRadius: "0.5rem",
                }}
                onClick={() => history.push("/dashboard")}
              >
                Store: {store.storename}
              </Button>
            )}

            {!hideHomeButton && (
              <Tooltip title="Home">
                <IconButton onClick={() => history.push("/home")}>
                  <HomeIcon />
                </IconButton>
              </Tooltip>
            )}
            {showUserManagement && (
              <Tooltip title="User Management">
                <IconButton onClick={() => history.push("/activeUsers")}>
                  <Group />
                </IconButton>
              </Tooltip>
            )}
            {showAppsIcon && (
              <Tooltip title="Go to Apps">
                <IconButton onClick={() => history.push("/apps")}>
                  <AppsIcon />
                </IconButton>
              </Tooltip>
            )}
            <Divider orientation="vertical" flexItem />
            <UserProfile />
          </Toolbar>
        </AppBar>
        {!hideDrawer && (
          <Drawer
            classes={{
              paper: clsx(
                classes.drawerPaper,
                !open && classes.drawerPaperClose
              ),
            }}
            open={open}
            variant="permanent"
            style={{ height: "100vh", marginLeft: "5%" }}
          >
            <div>
              <div className={classes.toolbarIcon}>
                <Typography
                  component="h5"
                  variant="h6"
                  noWrap
                  className={classes.title}
                >
                  <Button
                    onClick={open ? handleDrawerClose : handleDrawerOpen}
                    startIcon={<TimelineIcon fontSize="small" />}
                    size="small"
                    style={{ fontSize: "0.7rem" }}
                  >
                    AIMS
                  </Button>
                </Typography>
              </div>
              {showBaseMenu && (
                <MenuListItems menuItems={modules} showSectionTop={true} />
              )}
              {!showBaseMenu && (
                <List onClick={handleDrawerClose}>{menuItems}</List>
              )}
              <Divider />
            </div>
            <div>
              <Divider />
              {showBaseMenu && (
                <MenuListItems menuItems={modules} showSectionTop={false} />
              )}
              {!showBaseMenu && (
                <List onClick={handleDrawerClose}>{menuItems}</List>
              )}
              <Divider />
            </div>
          </Drawer>
        )}
        <main className={classes.content}>
          <div className={classes.appBarSpacer} />
        </main>
      </div>
    </ClickAwayListener>
  );
}
